export const openPopup = (url, winName, w, h, scroll) => {
	const LeftPosition = screen.width ? (screen.width - w) / 2 : 0
	const TopPosition = screen.height ? (screen.height - h) / 2 : 0
	const settings =
		'height=' +
		h +
		',width=' +
		w +
		',top=' +
		TopPosition +
		',left=' +
		LeftPosition +
		',scrollbars=' +
		scroll +
		',resizable'
	return window.open(url, winName, settings)
}



// WEBPACK FOOTER //
// /opt/build/repo/packages/utils/openPopup.js